import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { GlobeIcon } from '@mote/assets/icons'
import { EditorTranslationLanguagesList } from './EditorTranslationLanguagesList'

export const TranslationPicker = ({ onTranslate }) => {
  const [showTranslation, setShowTranslation] = useState(false)

  const toggleTranslation = () => {
    setShowTranslation(state => !state)
  }

  const selectLanguage = langCode => {
    setShowTranslation(false)
    onTranslate(langCode)
  }

  return (
    <div>
      <StyledButton onClick={toggleTranslation}>
        <GlobeIcon />
      </StyledButton>

      {showTranslation && (
        <EditorTranslationLanguagesList
          onClose={toggleTranslation}
          onLanguageSelection={selectLanguage}
        />
      )}
    </div>
  )
}

const StyledButton = styled.button`
  outline: none !important;
  position: absolute;
  bottom: 12px;
  right: 0;
  border: 0;
  background: inherit;
  cursor: pointer;
`

TranslationPicker.propTypes = {
  isConfirmed: PropTypes.bool,
  onTranslate: PropTypes.func.isRequired
}
